export default __webpack_public_path__ + "static/media/login-background.cd7a59b0.png";